// extracted by mini-css-extract-plugin
module.exports = {"page":"LoadingPage_page__2yJvu","spinner":"LoadingPage_spinner__1q-tT","spinnerSector":"LoadingPage_spinnerSector__3mcdJ","rotate":"LoadingPage_rotate__3ofSN"};